import { generatePath } from "react-router-dom";
import type { Path } from "@/router";

import { MEMBER_ELECTIONS_PENDING_PATH } from "../constants";

export const MEMBER_ELECTIONS_PATH = MEMBER_ELECTIONS_PENDING_PATH;

export function buildMemberElectionPersonPath(
  pgaId: string | null | undefined,
  searchParamsUrl = "",
  isCompactLayout = false
): Path | null {
  if (!pgaId) {
    return null;
  }

  const returnToQuery = searchParamsUrl ? `&${searchParamsUrl}` : "";

  if (isCompactLayout) {
    return `${generatePath(`/people/:pgaId`, { pgaId })}?return_to=${MEMBER_ELECTIONS_PATH}${returnToQuery}` as Path;
  }

  return generatePath(`/people/:pgaId/person/overview?return_to=${MEMBER_ELECTIONS_PATH}${returnToQuery}`, {
    pgaId
  }) as Path;
}
